import { SceneLightProps } from "./types";
import React from "react";
import NVSLight from "./NVSLight";

export type NVSMulitpleSceneLightProps = { lights?: SceneLightProps[] };

const NvsSceneLights: React.FC<NVSMulitpleSceneLightProps> = ({ lights }) => {
  return (
    <>
      {lights?.map((light, index) => {
        return <NVSLight {...light} key={index} />;
      })}
    </>
  );
};

export default NvsSceneLights;
